module.exports = __webpack_public_path__ + "img/references.58066dfd.svg";